<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                基站管理
                <small>片区管理</small>
            </h1>
            <ol class="breadcrumb">
                <li>
                    <a href="#">
                        <i class="fa fa-dashboard"></i> 基站管理
                    </a>
                </li>
                <li class="active">片区管理</li>
            </ol>
        </section>
        <!-- Main content -->
        <section class="content">
            <div class="col-sm-12">
                <div id="atptoolbar">
                    <button class="btn btn-success" type="button" id="addlayer" @click="addlayer">
                        <!-- data-toggle="modal" data-target="#sys_addlayer_modal" -->
                        <i class="fa fa-plus"></i>&nbsp;添加片区
                    </button>
                    <button class="btn btn-info" type="button" id="editlayer" @click="editlayer">
                        <i class="fa fa-pencil-square-o"></i>&nbsp;编辑片区
                    </button>
                    <button class="btn btn-danger" type="button" @click="dellayer">
                        <i class="fa fa-sign-in"></i>&nbsp;删除片区
                    </button>
                </div>
                <table id="atptable" data-show-columns="true"></table>
            </div>
        </section>
        <!-- /.content -->
        <!-- 模态框 -->
        <v-addlayer :msg-layerid="layerid" :msg-layerinfo="layerInfo" ref="aboutLayer"></v-addlayer>
    </div>
</template>

<script>
  import addlayer from './addlayer' // 添加片区
  export default {
    name: '',
    data () {
      return {
        layerid: '',
        layerInfo: '',
        companyId: ''
      }
    },
    components: {
      'v-addlayer': addlayer
    },
    mounted: function () {
      var self = this
      var companyId = JSON.parse(localStorage.getItem('companyInfo')).id
      self.companyId = companyId
      self.getlayer()
    },
    methods: {
      getlayer: function () {
        var self = this
        $('#atptable').bootstrapTable({
          url:
            self.global.apiHost + 'organization/' + self.companyId + '/layers/', //请求后台的URL（*）
          method: 'get', //请求方式（*）
          ajaxOptions: {
            headers: {
              'content-type': 'application/json', // 默认值
              Authorization: 'Bearer ' + localStorage.getItem('access_token')
            }
          },
          toolbar: '#atptoolbar', //工具按钮用哪个容器
          height: $(window).height() * 0.9,
          striped: true, //是否显示行间隔色
          cache: false, //是否使用缓存，默认为true，所以一般情况下需要设置一下这个属性（*）
          pagination: true, //是否显示分页（*）
          iconSize: 'outline',
          sortable: true, //是否启用排序
          sortName: 'stst_atpid',
          sortOrder: 'DESC', //排序方式
          queryParams: self.queryParams, //传递参数（*）
          sidePagination: 'server', //分页方式：client客户端分页，server服务端分页（*）
          pageNumber: 1, //初始化加载第一页，默认第一页
          pageSize: 10, //每页的记录行数（*）
          pageList: [10], //可供选择的每页的行数（*）
          search: true, //是否显示表格搜索，此搜索是客户端搜索，不会进服务端，所以，个人感觉意义不大
          showColumns: true, //是否显示所有的列
          showRefresh: true, //是否显示刷新按钮
          minimumCountColumns: 2, //最少允许的列数
          clickToSelect: true, //是否启用点击选中行
          singleSelect: true,
          uniqueId: 'stst_atpid', //每一行的唯一标识，一般为主键列
          fixedColumns: true,
          fixedNumber: 3,
          responseHandler: function (res) {
            console.log('___res 图层数据', res)
            return {
              total: res.length, //总页数
              rows: res //数据
            }
          },
          columns: [
            [
              { checkbox: true },
              {
                title: '序号',
                width: 40,
                formatter: function (value, row, index) {
                  var option = $('#atptable').bootstrapTable('getOptions')
                  return option.pageSize * (option.pageNumber - 1) + index + 1
                }
              },
              {
                title: '片区名称',
                field: 'name'
              },
              {
                title: '负责人姓名',
                field: 'principal',
                formatter: function (value, row, index) {
                  if (value) {
                    return value.username
                  } else {
                    return null
                  }
                }
              },
              {
                title: '负责人昵称',
                field: 'principal',
                formatter: function (value, row, index) {
                  if (value) {
                    return value.nick_name
                  } else {
                    return null
                  }
                }
              },
              {
                title: '负责人头像',
                field: 'principal',
                formatter: function (value, row, index) {
                  if (value) {
                    return (
                      '<img src="' +
                      value.avatar_url +
                      '" style="width:80px;height:80px;">'
                    )
                  } else {
                    return null
                  }
                }
              }
            ]
          ],
          onDblClickRow: function (row) {},
          onSort: function (name, order) {},
          onLoadSuccess: function () {},
          onClickRow: function (row, $element) {}
        })
      },
      queryParams: function () {},
      //添加图层
      addlayer: function () {
        var self = this
        $('#sys_addlayer_modal').modal('show')
        setTimeout(function () {
          self.$refs.aboutLayer.intfn('add')
        }, 500)
      },
      editlayer: function () {
        var self = this
        var getSelections = $('#atptable').bootstrapTable('getSelections')
        if (getSelections.length != 1) {
          alert('请选择片区')
          return
        } else {
          var layerid = getSelections[0].id
          self.layerid = layerid
          self.layerInfo = JSON.stringify(getSelections[0])
          $('#sys_addlayer_modal').modal('show')
          setTimeout(function () {
            self.$refs.aboutLayer.intfn('edit')
          }, 500)
        }
      },
      dellayer: function () {
        var self = this
        var getSelections = $('#atptable').bootstrapTable('getSelections')
        if (getSelections.length != 1) {
          alert('请选择片区')
          return
        } else {
          var layerid = getSelections[0].id
          self.layerid = layerid
          var r = confirm('您确定要删除该片区?') // 询问框里的文字描述
          if (r == true) {
            self.global.axiosDelete(
              self,
              'layer/' + layerid + '/',
              function (res) {
                alert('删除成功')
                $('#atptable').bootstrapTable('refresh')
              },
              function () {
                alert('没有权限')
              }
            )
          } else {
            console.log('取消')
          }
        }
      }
    }
  }
</script>
<style scoped>
    .col-sm-12 {
        background: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/views/stationmanager/layermanager.vue